import React, { type ReactNode } from "react";
import { Text, type PlacementWithLogical, Tooltip as ChakraTooltip } from "@chakra-ui/react";

type TooltipProps = {
  /**
   * Tooltip message.
   */
  message: string;

  /**
   * The placement of the tooltip.
   *
   * @default "auto"
   */
  placement?: PlacementWithLogical;

  /**
   * Element to show tooltip around.
   */
  children: ReactNode;
};

export function Tooltip({ message, children, placement = "auto" }: TooltipProps) {
  return (
    <ChakraTooltip
      hasArrow
      label={
        <Text as="span" color="brand.text.light" wordBreak="break-word">
          {message}
        </Text>
      }
      placement={placement}
    >
      <Text as="span" textDecoration="underline" textDecorationStyle="dotted" textUnderlineOffset="2px">
        {children}
      </Text>
    </ChakraTooltip>
  );
}
